import './index.less';
import { CarouselFrontend } from './component/carousel/carousel-frontend';
import { CarouselUniversalFrontend } from './component/carousel-universal/carousel-universal-frontend';
import { YoutubeFrontend } from './component/youtube/youtube-frontend';
import { BoxesFrontend } from './component/boxes/boxes-frontend';
import { ColorsCommon } from './component/color-card/color-common';
import { ProductsCommon } from './component/product-card/product-common';
import { CardSectionService } from './component/card-section/card-section-common';
import { PressReleaseCommon } from './component/press-releases/press-release-common';
import { ProductsSearchCommon } from './component/products-a-z/products-search-common';
import { BlogSearchCommon } from './blog/blog-search';
import { ProductDetailColorSearchCommon } from './component/products-a-z/product-detail-color-search-common';
//import { CalculatorColorSearchCommon } from './component/products-a-z/calculator-color-search-common';
import { SiteSearchCommon } from './site-search/site-search';
import * as PrAZ from './component/products-a-z/products-az-common';
import './component/home-billboard/home-billboardjs.js';
import './component/home-quicklinks/home-quicklinksjs.js';
import './component/document/documentjs.js';
import './component/form-components/simple/color-picker/color-picker.js';
import './component/form-components/simple/color-search/color-search.js';
import { FormCommon } from './component/form-components/form/form-common';
import { CountryCardCommon } from './component/country-card/country-card-common';
import { ImageCommon } from './component/image/image-common';
import { initBillboardCarousel } from './component/billboard-carousel/billboard-carousel-frontend';
import { TimelineCommon } from './component/timeline/timeline-common';
import { AccordionCommon } from './component/accordion/accordion-common';
import { RepeatableFieldGroupFrontend } from './component/form-components/simple/repeatable-field-group/repeatable-field-group-frontend'
import {iframeFrontend} from "./component/iframe/iframe-frontend";



// ImageCommon.init();
CarouselFrontend.init();
CarouselUniversalFrontend.init();
YoutubeFrontend.init();
BoxesFrontend.init();
ProductsCommon.init();
CardSectionService.initSection();
// PressReleaseCommon.init();
// ProductsSearchCommon.init();
// PrAZ.ProductsAZ.ProductAZCommon.init();
// ProductDetailColorSearchCommon.init();
//CalculatorColorSearchCommon.init();
SiteSearchCommon.init();
// FormCommon.initForms();
CountryCardCommon.init();
initBillboardCarousel();
// TimelineCommon.init();
AccordionCommon.initAll();
// BlogSearchCommon.init();
// RepeatableFieldGroupFrontend.init();
ColorsCommon.init();
iframeFrontend.init();
